import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_4 = { class: "link" }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = { class: "d-flex justify-end" }
const _hoisted_7 = { style: {"background-color":"#f4f4f4"} }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Add users to a group to give those users access to the applications available to that group.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Add applications to a group to easily assign application access to a group of users.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateGroup = _resolveComponent("CreateGroup")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AssignUsers = _resolveComponent("AssignUsers")!
  const _component_AssignApplications = _resolveComponent("AssignApplications")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "#F4F4F4",
                      variant: "flat",
                      class: "pa-2",
                      height: "48"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          dense: "",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              md: "8"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CreateGroup, {
                                          system: false,
                                          submit: _ctx.createUserGroup,
                                          disabled: _ctx.disabled,
                                          group: _ctx.group,
                                          loading: _ctx.loading,
                                          "reset-dialog": _ctx.resetDialog,
                                          removeUserFromGroup: _ctx.removeUserFromGroup,
                                          removeApplicationAccessFromGroup: _ctx.removeApplicationAccessFromGroup,
                                          onFetchGroups: _ctx.fetchGroups
                                        }, null, 8, ["submit", "disabled", "group", "loading", "reset-dialog", "removeUserFromGroup", "removeApplicationAccessFromGroup", "onFetchGroups"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.selectedGroups.some((g) => !g.tenantId) && !_ctx.userStore.isSuperAdmin)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              "open-delay": "200",
                                              location: "bottom",
                                              text: "System groups can only be edited by super users"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                  _createVNode(_component_v_btn, {
                                                    size: "small",
                                                    variant: "plain",
                                                    color: "primary",
                                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeUserGroup())),
                                                    disabled: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove user group' : 'Remove'), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 16)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              size: "small",
                                              variant: "plain",
                                              color: "primary",
                                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeUserGroup()))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove user group' : 'Remove'), 1)
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          onClick: _ctx.removeUsersFromGroups,
                                          size: "small",
                                          variant: "plain",
                                          color: "primary",
                                          disabled: !Object.values(_ctx.selectedUsers).some(arr => arr.length > 0)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Unassign users' : 'Remove'), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          "hide-details": "",
                                          density: "compact",
                                          placeholder: "Search groups or users",
                                          "append-inner-icon": "mdi-magnify",
                                          modelValue: _ctx.searchNames,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchNames) = $event)),
                                          variant: "underlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      items: _ctx.combinedGroups,
      headers: _ctx.headers,
      "return-object": "",
      height: "calc(100vh - 260px)",
      "expand-on-click": "",
      modelValue: _ctx.selectedGroups,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedGroups) = $event)),
      "sort-by": [{key: 'name', order: 'asc'}],
      "items-per-page": "-1",
      expanded: _ctx.expandedGroups
    }, {
      [`header.data-table-expand`]: _withCtx(() => [
        (_ctx.expandedGroups.length === _ctx.combinedGroups.length)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "",
              variant: "text",
              size: "small",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandedGroups = []))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-chevron-double-up")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              icon: "",
              variant: "text",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandedGroups = [..._ctx.combinedGroups]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-chevron-double-down")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      [`item.users`]: _withCtx(({ item }) => [
        _createVNode(_component_v_chip, {
          color: "primary",
          variant: "flat",
          size: "small",
          class: "font-weight-bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.userCount[item.id] || 0) + " user" + _toDisplayString(_ctx.userCount[item.id] > 1 || _ctx.userCount[item.id] === 0 ? 's' : '') + " assigned", 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.access`]: _withCtx(({ item }) => [
        (!item.tenantId)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 0,
              color: "grey",
              variant: "tonal",
              size: "small",
              class: "font-weight-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode("System group")
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_chip, {
              key: 1,
              color: "grey-darken-4",
              variant: "tonal",
              size: "small",
              class: "font-weight-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode("User group")
              ]),
              _: 1
            }))
      ]),
      [`item.applications`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications, (app) => {
            return (_openBlock(), _createElementBlock("div", {
              key: app.id,
              class: "mr-n2"
            }, [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "open-delay": "200"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_avatar, _mergeProps({
                    class: "font-weight-bold",
                    size: "32",
                    style: {"border":"2px solid #ffffff"},
                    color: "primary",
                    icon: "",
                    variant: "flat",
                    onClick: _withModifiers(($event: any) => {_ctx.currentGroup = {...item}; _ctx.currentApplication = app;}, ["stop"])
                  }, props), {
                    default: _withCtx(() => [
                      (!app.icon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(app.name?.charAt(0)), 1))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            color: "white",
                            size: "18"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-" + _toDisplayString(app.icon), 1)
                            ]),
                            _: 2
                          }, 1024))
                    ]),
                    _: 2
                  }, 1040, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(app.name), 1)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          (item.outOfScopeApplicationCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_tooltip, {
                  location: "bottom",
                  "open-delay": "200"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _mergeProps(props, {
                      class: item.applications.length ? 'ml-2' : ''
                    }), [
                      _createElementVNode("a", _hoisted_4, "(" + _toDisplayString(item.outOfScopeApplicationCount) + " out of account scope)", 1)
                    ], 16)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" This group has applications assigned that this account does not have access to ")
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true),
          (item.applications.length > 5)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 1,
                location: "bottom",
                "open-delay": "200"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                    _createElementVNode("a", _hoisted_5, "+ " + _toDisplayString(item.applications.length - 5) + " more", 1)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications.slice(5), (app) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: app.id
                    }, _toDisplayString(app.name), 1))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_btn, _mergeProps(props, {
                size: "32",
                icon: "",
                variant: "flat",
                color: "primary"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-dots-vertical")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (item.tenantId)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      onClick: ($event: any) => {_ctx.currentGroup = {...item}; _ctx.editGroup(item);},
                      "prepend-icon": "mdi-pencil",
                      title: "Edit group"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (item.tenantId)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      onClick: ($event: any) => {_ctx.currentGroup = {...item}; _ctx.editGroupApplicationsDialog = true;},
                      "prepend-icon": "mdi-application-edit",
                      title: "Edit applications"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => {_ctx.openEditUsersDialog(item);},
                  "prepend-icon": "mdi-account-multiple-plus",
                  title: "Edit users"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      "expanded-row": _withCtx(({ columns, item }) => [
        _createElementVNode("tr", _hoisted_7, [
          _createElementVNode("td", {
            colspan: columns.length,
            class: "px-0"
          }, [
            _createVNode(_component_v_card, {
              class: "",
              variant: "flat"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  density: "compact",
                  class: "subTable",
                  items: item.users,
                  headers: _ctx.subHeaders,
                  modelValue: _ctx.selectedUsers[item.id],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.selectedUsers[item.id]) = $event),
                  "return-object": "",
                  "show-select": ""
                }, {
                  [`item.full_name`]: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(_ctx.fullName(item.first_name, item.last_name)), 1)
                  ]),
                  bottom: _withCtx(() => []),
                  _: 2
                }, 1032, ["items", "headers", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_8)
        ])
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue", "expanded"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editGroupDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editGroupDialog) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "Edit system group" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "hide-details": "",
                              density: "compact",
                              label: "Group name",
                              modelValue: _ctx.currentGroup.name,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentGroup.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.disabled,
                  color: "primary",
                  onClick: ($event: any) => {_ctx.saveUserGroup(); isActive.value = false}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save user group ")
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editUsersDialog,
      "onUpdate:modelValue": [
        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editUsersDialog) = $event)),
        _ctx.resetDialog
      ]
    }, {
      default: _withCtx(({  }) => [
        _createVNode(_component_v_card, { title: "And or remove users from the group" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_AssignUsers, {
                  currentGroup: _ctx.currentGroup,
                  onUpdateUsersToAdd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.usersToAdd = $event)),
                  removeUserFromGroup: _ctx.removeUserFromGroup
                }, null, 8, ["currentGroup", "removeUserFromGroup"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateUsersInGroup(_ctx.currentGroup))),
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save group ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editGroupApplicationsDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editGroupApplicationsDialog) = $event)),
      onAfterLeave: _ctx.resetDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { title: "And or remove group applications" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_AssignApplications, {
                  currentGroup: _ctx.currentGroup,
                  applications: _ctx.applications,
                  onUpdateAppsToAdd: _cache[11] || (_cache[11] = ($event: any) => (_ctx.appsToAdd = $event)),
                  removeApplicationAccessFromGroup: _ctx.removeApplicationAccessFromGroup
                }, null, 8, ["currentGroup", "applications", "removeApplicationAccessFromGroup"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateApplicationAccessForGroup(_ctx.currentGroup))),
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save group ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onAfterLeave"])
  ]))
}